import { useEffect, useRef, useState } from 'react';
import Marquee from 'react-fast-marquee';
import { useInView, animate } from 'framer-motion';
import { useContent } from '@/lib/content';
import { Reveal } from '@/components/Reveal';

const MARQUEE_ITEMS = ['1000+ Events Executed', '100+ 5-Star Reviews', 'Award-Winning Event Planner', '4500+ Instagram Followers', 'End-to-End Event Management'];

const Counter = ({ to, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-40px' });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, { duration: 2.2, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setVal(Math.round(v)) });
    return () => controls.stop();
  }, [inView, to]);
  return (
    <span ref={ref} className="font-serif text-5xl sm:text-6xl font-light text-cream">
      {val.toLocaleString('en-IN')}
      <span className="text-champagne">{suffix}</span>
    </span>
  );
};

export const StatsBand = () => {
  const { settings } = useContent();
  const stats = settings.stats || [];
  return (
  <>
    <div data-testid="trust-marquee" className="bg-cream text-ink py-4 border-y border-ink/10">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {MARQUEE_ITEMS.map((item) => (
          <span key={item} className="mx-8 text-xs sm:text-sm uppercase tracking-[0.35em] font-medium flex items-center gap-8">
            {item} <span className="text-champagne-dark">•</span>
          </span>
        ))}
      </Marquee>
    </div>
    <div data-testid="stats-band" className="border-b border-white/10">
      <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4">
        {stats.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1} className={`px-6 py-12 sm:py-16 text-center ${i !== 0 ? 'border-l border-white/10' : ''} ${i >= 2 ? 'border-t lg:border-t-0 border-white/10' : ''}`}>
            <Counter to={s.value} suffix={s.suffix} />
            <p className="mt-3 text-[11px] uppercase tracking-[0.3em] text-white/50">{s.label}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </>
  );
};
